require('./bootstrap');

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const store = new Vuex.Store({
  state: {
    loading: true,
    dropdownOpen: false,
    shouldAuth: false,
    exams: [],
    products: [],
    user: null,
    adminId: null,
    pendingAction: null,
    userProducts: [],
    pendingTransactions: [],
    cities: [],
    majors: [],
    currentPath: '/',
    errors: {},
    purchasedProducts: [],
    giftProducts: [],
    roles: [],
    settings: null,
    primaryExam: null,
    printing: false,
    voucher: '',
    questions: [],
    module: null,
    questionBySection: [],
    ownedExams: [],
    userModules: [],
    moduleRankingData: [],
    sponsorPopUpOpen: false,
    tryoutUrl: '',
    now: Vue.moment(),
  },
  getters: {
    auth (state) {
        return state.user != null;
    },
    userProductById: state => id => _.find(state.userProducts, {id}),
    userModuleByFilter: state => filter => _.find(state.userModules, filter),
    userProductIndexById: state => id => _.findIndex(state.userProducts, {id}),
    pendingTransactionById: state => id => _.find(state.pendingTransactions, {id}),
    userProductTotalAmount (state) {
        return _.sumBy(state.userProducts, 'amount');
    },
    userProductTotalPrice (state) {
        return _.sumBy(state.userProducts, function(item) {
            return item.amount * item.product.price;
        });
    },
    userProductTotalDiscPrice (state) {
        let minus = 0;
        let tes = _.sumBy(state.userProducts, function(item) {
            minus = item.product.cart_discount;
            return item.product.cart_discount;
        })
        return tes-minus;
    },
    pendingTransactionsTotal (state) {
        return state.pendingTransactions.length;
    },
    purchasedProductById: state => id => _.find(state.purchasedProducts, {id}),
    giftProductById: state => id => _.find(state.giftProducts, {id}),
    ownedExamByUserProductDetailId: state => user_product_detail_id => _.find(state.ownedExams, {user_product_detail_id}),
    ownedProductTotalAmount (state) {
        return _.sumBy(state.purchasedProducts, 'details.length') + state.giftProducts.length;
    },
  },
  mutations: {
     setLoading (state, payload) {
      state.loading = payload;
    },
    setDropdownOpen (state, payload) {
      state.dropdownOpen = payload;
    },
    setCurrentPath (state, payload) {
      state.currentPath = payload;
    },
    shouldAuth (state, payload) {
        state.shouldAuth = payload;
    },
    setUser (state, payload) {
      state.user = payload;
    },
    setAdminId (state, payload) {
      state.adminId = payload;
    },
    setProducts (state, payload) {
        state.products = payload;
    },
      setExams(state, payload) {
          state.exams = payload;
      },
    setPendingAction (state, payload) {
        state.pendingAction = payload;
    },
    setUserProducts (state, payload) {
        state.userProducts = payload;
    },
    setPendingTransactions (state, payload) {
        state.pendingTransactions = payload;
    },
    setCities (state, payload) {
        state.cities = payload;
    },
    setMajors (state, payload) {
        state.majors = payload;
    },
    updateUserProductById (state, payload) {
        Object.assign(_.find(state.userProducts, {id: payload.id}), payload);
    },
    updatePurchasedProductDetailById (state, payload) {
        let purchasedProducts = state.purchasedProducts;
        for (let i = 0; i < purchasedProducts.length; i++) {
            let detailIndex = _.findIndex(purchasedProducts[i].details, {id: payload.id});
            if (detailIndex >= 0) {
                Object.assign(purchasedProducts[i].details[detailIndex], payload);
                Object.assign(state.purchasedProducts, purchasedProducts);
                return;
            }
        }
    },
    updateGiftProductById (state, payload) {
        var detailIndex = _.findIndex(state.giftProducts, {id: payload.id});
        if (detailIndex >= 0) {
            let giftProducts = state.giftProducts;
            Object.assign(giftProducts[detailIndex], payload);
            Object.assign(state.giftProducts, giftProducts);
        }

    },
    deleteUserProductById (state, payload) {
        var index = _.findIndex(state.userProducts, {id: payload});
        state.userProducts.splice(index, 1);
    },
    deletePendingTransactionById (state, payload) {
        var index = _.findIndex(state.pendingTransactions, {id: payload});
        state.pendingTransactions.splice(index, 1);
    },
    addUserProductDetail (state, payload) {
        var userProduct = _.find(state.userProducts, {id: payload.user_product_id});
        userProduct.details.push(payload.data);
    },
    popUserProductDetail (state, payload) {
        _.find(state.userProducts, {id: payload}).details.pop();
    },
    setErrors (state, payload) {
        state.errors = payload;
    },
    setPurchasedProducts (state, payload) {
        state.purchasedProducts = payload;
    },
    setGiftProducts (state, payload) {
        state.giftProducts = payload;
    },
    setRoles (state, payload) {
        state.roles = payload;
    },
    setSettings (state, payload) {
        state.settings = payload;
    },
    setPrimaryExam (state, payload) {
        state.primaryExam = payload;
    },
    setPrinting (state, payload) {
        state.printing = payload;
    },
    setVoucher (state, payload) {
        state.voucher = payload;
    },
    setQuestions (state, payload) {
        state.questions = payload;
    },
    setModule (state, payload) {
        state.module = payload;
    },
    setQuestionBySection (state, payload) {
        state.questionBySection = payload;
    },
    setOwnedExams (state, payload) {
        state.ownedExams = payload;
    },
    setUserModules (state, payload) {
        state.userModules = payload;
    },
    setModuleRankingData (state, payload) {
        state.moduleRankingData = payload;
    },
    setSponsorPopUpOpen (state, payload) {
      state.sponsorPopUpOpen = payload;
    },
    setTryoutUrl (state, payload) {
      state.tryoutUrl = payload;
    },
    setNow (state, payload) {
      state.now = Vue.moment(payload);
    },
  },
  actions: {
    async loadExams(context) {
        var response = await axios.get('/resource/exams');
        context.commit('setExams', response.data.data);
    },
    async loadProducts(context) {
        var response = await axios.get('/resource/products');
        context.commit('setProducts', response.data.data);
    },
    async loadUser (context) {
        var response = await axios.get('/resource/user');
        context.commit('setUser', response.data.data);
    },
    async loadAdminId (context) {
        var response = await axios.post('/admin-id');
        context.commit('setAdminId', response.data);
    },
    async loadUserProducts (context) {
        var response = await axios.get('/resource/cart');
        context.commit('setUserProducts', response.data.data);
    },
    async pushUpdateUserProductDetail (context, payload) {
        var response = await axios.post('/user-product-detail', payload);
        if (response.data.data != undefined)  {
            context.commit('updatePurchasedProductDetailById', response.data.data);
            context.commit('updateGiftProductById', response.data.data);
        }
    },
    async pushUpdateUser (context, payload) {
        var response = await axios.post('/user', payload);
        if (response.data.data != undefined)  {
            await context.dispatch('loadUser');
        }
    },
    async loadPendingTransactions (context) {
        var response = await axios.get('/resource/pending-transactions');
        context.commit('setPendingTransactions', response.data.data);
    },
    async loadCities (context) {
        var response = await axios.get('/resource/cities');
        context.commit('setCities', response.data.data);
    },
    async loadMajors (context) {
        var response = await axios.get('/resource/majors');
        context.commit('setMajors', response.data.data);
    },
    async addToCart (context, product_id) {
        await axios.post('/cart/add', {product_id});
        context.dispatch('loadUserProducts');
    },
    async pushDeleteUserProductById (context, user_product_id) {
        await axios.get('/cart/remove/' + user_product_id);
    },
    async pushDeleteTransactionById (context, transaction_id) {
        await axios.post('/transaction/remove', {id: transaction_id});
    },
    async continueAction (context) {
        if (context.state.pendingAction != null) {
            var action = context.state.pendingAction;
            await context.dispatch(action.type, action.payload);
            context.commit('setPendingAction', null);
        }
    },
    async pay (context) {
        var cart = _.map(context.state.userProducts, function ({id, amount, details, city_id, major_id}) {
            return {id, amount, details, city_id, major_id};
        });
        let voucher = context.state.voucher;
        return axios.post('/pay', { cart, voucher });
    },
    async loadPurchasedProducts (context) {
        var response = await axios.get('/resource/primary-purchased-products');
        context.commit('setPurchasedProducts', response.data.data);
    },
    async loadGiftProducts (context) {
        var response = await axios.get('/resource/primary-gift-products');
        context.commit('setGiftProducts', response.data.data);
    },
    async loadRoles (context) {
        var response = await axios.get('/resource/roles');
        context.commit('setRoles', response.data.data);
    },
    async loadUserModule (context, payload) {
        var response = await axios.get('/resource/user-module/' + payload.module_id + '/' + payload.exam_id + '/' + payload.user_product_detail_id);
        context.commit('setModule', response.data.data);
    },
    async loadQuestionBySection (context, payload) {
        let key = [
            context.state.user.id,
            payload.module_id,
            payload.exam_id,
        ].join('_');
        let savedData = JSON.parse(localStorage.getItem(key));

        if (payload.no_cache) {
            savedData = null;
        }

        if (savedData != null) {
            context.commit('setQuestionBySection', savedData);
            for (let i = 0; i < context.state.questionBySection.length; i++) {
                let section = context.state.questionBySection[i];
                let currentQuestion = section.currentQuestion;
                for (let j = 0; j < section.questions.length; j++) {
                    let question = section.questions[j];
                    if (currentQuestion != null && question.id == currentQuestion.id) {
                        section.currentQuestion = question;
                        currentQuestion == null;
                    }
                    if (question.chosenAnswer != null) {
                        let chosenAnswer = question.chosenAnswer;
                        question.chosenAnswer = null;
                        for (let k = 0; k < question.answers.length; k++) {
                            let answer = question.answers[k];
                            if (answer.question_answer_id == chosenAnswer.question_answer_id) {
                                question.chosenAnswer = answer;
                                break;
                            }
                        }
                    }
                    if (question.multipleAnswer.length != 0) {
                        let multipleAnswer = question.multipleAnswer;
                        question.multipleAnswer = [];
                        for (let k = 0; k < question.answers.length; k++) {
                            let answer = question.answers[k];

                            for (let l = 0; l < multipleAnswer.length; l++) {
                                if (answer.question_answer_id == multipleAnswer[l].question_answer_id) {
                                    question.multipleAnswer.push(answer);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        } else {
            var response = await axios.post('/resource/question-by-section', payload);
            context.commit('setQuestionBySection', response.data.data);
        }
    },
    async loadOwnedExams (context) {
        var response = await axios.get('/resource/primary-owned-exams');
        context.commit('setOwnedExams', response.data.data);
    },
    async loadUserModules (context) {
        var response = await axios.get('/resource/user-modules');
        context.commit('setUserModules', response.data.data);
    },
    async loadModuleRankingData (context, payload) {
        var response = await axios.get('/modules/' + payload + '/ranking-data');
        context.commit('setModuleRankingData', response.data);
    }
  },
});

import { mapState } from 'vuex';

const app = new Vue({
    el: '#app',
    store,
    data: function() {
      return {
        style: {},
      };
    },
    computed: {
      ...mapState(['primaryExam'])
    },
    watch: {
      primaryExam(newItem, oldItem) {
        if (newItem != null && newItem.background != undefined) {
          Vue.set(this.style, 'backgroundImage', 'url(/storage/' + newItem.background + ')');
        }
      }
    },
    mounted() {
        this.$nextTick(function () {
            this.$store.commit('setLoading', false);
        })
    },
    methods: {
        bodyClick() {
            this.$store.commit('setDropdownOpen', false);
        }
    },
});

window.app = app;
